import PropTypes from 'prop-types';

export const SearchProducts = Object.freeze({
    DYNPACK: 'dynpack',
    FLIGHTS: 'flights',
    INSPIRATIONAL: 'inspirations',
    HOTEL_STANDALONE: 'hotel_standalone',
    HOTELS_HOME: 'hotels_home'
});

export const SearchProductsProp = PropTypes.oneOf(Object.values(SearchProducts));
